<template><div><h1 id="profil" tabindex="-1"><a class="header-anchor" href="#profil"><span>Profil</span></a></h1>
<p>Profil — Marketingprofil der Adresse</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Zeigt ein Marketingprofil der aktuellen Adresse, welches die Kundenstatus-Definition in funtrade berücksichtigt (siehe Adressenstamm: Daten). Berücksichtigt werden dabei Häufigkeit der Zahlungen, der durchschnittliche Umsatz, die Anzahl Refusés sowie der Gesamtumsatz. Ebenfalls gezeigt wird der aktuelle Saldo des Debitors sowie allfällig vorhandene Sperren.</p>
<h3 id="adress-sperren" tabindex="-1"><a class="header-anchor" href="#adress-sperren"><span>Adress-Sperren</span></a></h3>
<p>Im Profil sind die aktuellen Sperren zu einer Adresse sichtbar. Im folgenden sind die möglichen Sperren beschrieben.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Datenpflege → Personenstatus und Profil aktualisieren</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>erster/letzter Umsatz</dt>
<dd>Pro Bereich (Zusagen/Spenden/Käufe) wird das Jahr des ersten und letzten Umsatzes gezeigt.</dd>
<dt>Frequenz</dt>
<dd>Pro Bereich wird die Frequenz angezeigt: Seit einem bestimmten Jahr (in der Regel 3 Jahre zurück) werden bei Spenden die Anzahl von Response und Initialereignissen gezeigt. Bei den Zusagen und Käufen wird die Anzahl der aktiven Jahren (Jahr mit bezahlten Zusage oder mit Kauf) seit einem bestimmten Jahr gezeigt.</dd>
<dt>Volumen</dt>
<dd>Umsatz in den Jahren (seit) in pro Response-Ereignis und pro Bereich.</dd>
<dt>Rücksendungen</dt>
<dd>Anzahl Refusé-Ereignisse (seit angegebenem Jahr) und pro Bereich.</dd>
<dt>Umsatz</dt>
<dd>Gesamtumsatz pro Bereich (seit angegebenen Jahr).</dd>
<dt>offene Forderungen</dt>
<dd>Zeigt die offenen Forderungen, resp. den geschuldeten Betrag an.</dd>
<dt>Guthaben</dt>
<dd>Zeigt allfällige Guthaben des Kunden an.</dd>
<dt>Publikationen</dt>
<dd>Zeigt die aktuell abonnierten Publikationen.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.adr.html" title="Person">Adresse</RouteLink></p>
</div></template>


